/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {GenerateDocumentModalComponent} from './generate-document-modal/generate-document-modal.component';

import {CollapseModule} from 'ngx-bootstrap/collapse';
import {SkeletonElementsModule} from 'skeleton-elements/angular';
import {TemplateManagementModule} from '../../template-management/template-management.module';
import {FilesModule} from '../files/files.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {ModalModule} from '../modal/modal.module';
import {MvelModule} from '../mvel/mvel.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';

@NgModule({
  declarations: [
    GenerateDocumentModalComponent
  ],
  exports: [
    GenerateDocumentModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiModule,
    TranslateModule,
    PipesModule,
    UserModule,
    ModalModule,
    FilesModule,
    SkeletonElementsModule,
    FormGeneratorModule,
    MvelModule,
    CollapseModule,
    TemplateManagementModule
  ]
})
export class GenerateDocumentModule {
}
